export enum SicalcUserRole {
  Administrator = "Administrator",
  AvinorUser = "AvinorUser",
  ForsvarsbyggUser = "ForsvarsbyggUser",
  IsaviaUser = "IsaviaUser",
  Consultant = "Consultant",
}


